export default "__VITE_ASSET__D9kdqBc4__"